<template>
  <div class="Top">
    <div class="toptext">
      <div class="img"></div>
      <span>装货地分布TOP</span>
    </div>
    <div id="goodsTop" :style="{ width: '450px', height: '250px' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    chartObjLeft2: {
      type: Object,
      default: function () {
        return {
          yData: [],
          seriesData: [],
          newSeriesData: []
        };
      }
    }
  },
  watch: {
    chartObjLeft2: {
      handler (data) {
        this.goodsChart(data.yData, data.seriesData, data.newSeriesData);
      },
      deep: true
    }
  },
  data () {
    return {
      mychart: null,
      option: {
        grid: {
          top: "5%",
          left: "26%",
          right: "10%",
          bottom: "14%"
          // containLabel: true
        },
        // 不显示x轴的相关信息
        xAxis: {
          show: true, //x的文字不显示
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "#826858"
            }
          }, //去除网格线
          splitArea: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: [1, 2, 3],
            animationDuration: 300,
            animationDurationUpdate: 300,
            max: 7, // only the largest 3 bars will be displayed
            // 不显示y轴的线
            axisLine: {
              show: false
            },
            // 不显示刻度
            axisTick: {
              show: false
            },
            // 把刻度标签里面的文字颜色设置为
            axisLabel: {
              fontSize: 14,
              textStyle: {
                color: function (value, index) {
                  return index < 3 ? '#fff' : '#6f81a7'
                }
              }
            }
          },

        ],
        series: [
          {
            type: "bar",
            data: [1, 2, 3],
            encode: { x: "value", y: "name" },
            realtimeSort: true,
            label: {
              color: "#fff",
              show: true,
              position: "right",
              valueAnimation: true,
              formatter: '{c}%'
            },
            yAxisIndex: 0,
            // 修改第一组柱子的圆角
            itemStyle: {
              barBorderRadius: [0, 5, 5, 0],
              // 此时的color 可以修改柱子的颜色
              color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "#30FBF5" },
                { offset: 1, color: "#0095F0" }
              ])
            },
            // 柱子之间的距离
            //柱子的宽度
            barWidth: 10
          }
        ],
        legend: {
          show: true
        },
        animationDuration: 0,
        animationDurationUpdate: 3000,
        animationEasing: "linear",
        animationEasingUpdate: "linear"
      }
    };
  },
  mounted () {
    this.goodsTop();
  },
  methods: {
    goodsTop () {
      this.mychart = this.$echarts.init(document.getElementById("goodsTop"));
      this.mychart.setOption(this.option);
    },
    goodsChart (yData, seriesData, newSeriesData) {
      if (newSeriesData == 0) {
        this.option.yAxis[0].data = yData;
        this.option.series[0].data = seriesData;
        this.option.series[0].label.show = false
        this.mychart.setOption(this.option);
      } else if (yData.lenght == 0 || seriesData.lenght == 0) {
        console.log("未接收到数据")
      } else {
        let baiData = []
        let seriesDataNew = seriesData
        let sum = ((newSeriesData[0] + newSeriesData[1] + newSeriesData[2] + newSeriesData[3]) / 1000)
        seriesDataNew.forEach(item => {
          baiData.push(
            // (Number(item) / (sum / 100))
            (Number(item) / (sum / 100)).toFixed(0)
          )
        });
        this.option.yAxis[0].data = yData;
        this.option.series[0].data = baiData;
        this.option.series[0].label.show = true
        this.mychart.setOption(this.option);
      }

    }
  }
};
</script>

<style scoped>
.Top {
  padding: 0;
  margin-top: 1%;
  width: 100%;
  height: 320px;
  background-image: url('../assets/img/微信图片_202106021523152.png');
  background-repeat: no-repeat;
  background-size: 100% 320px;
}
.toptext {
  display: flex;
  height: 40px;
  width: 100%;
  position: relative;
  padding-top: 10px;
  padding-left: 10px;
  background-image: url('../assets/img/微信图片_202106021523151.png');
  background-repeat: no-repeat;
  background-size: 90% 40%;
  background-position: bottom;
}
.toptext .img {
  width: 40px;
  height: 40px;
  background-image: url('../assets/img/微信图片_20210602152315.png');
  background-repeat: no-repeat;
  background-size: 110% 110%;
  background-position: center;
  position: absolute;
  top: 15px;
  left: 10px;
}
.toptext span {
  display: flex;
  padding-top: 15px;
  margin-left: 31px;
  color: aliceblue;
  font-family: 'PingFangSC-Regular';
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/goodstop.vue